import Config from '../config';

const countryCode = VERSION_CODE || 'de';
const currentConfig = Config[countryCode];

const EMBED_URL = currentConfig.embedUrl;

const APP_URL = currentConfig.appUrl;
const APP_URL_ENCODED = encodeURIComponent(APP_URL);

const SHARING_TEXT_ENCODED = encodeURIComponent(currentConfig.sharingText);

export function getEmbedCode() {
  return (`<iframe width="100%" height="980" src="${EMBED_URL}" frameborder="0" allowfullscreen></iframe>`);
}

export function getHrefFb() {
  return `https://www.facebook.com/sharer/sharer.php?u=${APP_URL_ENCODED}&t=${SHARING_TEXT_ENCODED}`;
}

export function getHrefTw() {
  return `https://twitter.com/intent/tweet?url=${APP_URL_ENCODED}&text=${SHARING_TEXT_ENCODED}`;
}

export function getHrefGp() {
  return `https://plus.google.com/share?url=${APP_URL_ENCODED}&type=st&rsz=1&client=3`;
}



// WEBPACK FOOTER //
// ./src/helper/sharing.js